import {useGetInsights, UseGetInsightsProps, UseGetInsightsResult} from "./useGetInsights";

export type UseGetRecentPipelineInsightsProps = Omit<UseGetInsightsProps, 'pipeline' | 'trucking'>

export type UseGetRecentPipelineInsightsResult = Pick<UseGetInsightsResult, 'statistics'>

export const useGetRecentPipelineInsights = (props: UseGetRecentPipelineInsightsProps): UseGetRecentPipelineInsightsResult => {
  const {...rest} = props

  const insights = useGetInsights({...rest, trucking: false, pipeline: true})

  return {
    ...insights,
  }
}
